var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero mt-2"},[_c('video',{staticClass:"video-banner",attrs:{"autoplay":"","muted":"","loop":"","playsinline":"","webkit-playsinline":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":require("../../assets/home-page-video.mp4"),"type":"video/mp4"}}),_vm._v("\n    Your browser does not support the video tag.\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }